import React, {
  useEffect, useRef, useState,
} from 'react';
import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';

interface Props {
  onChange: (e: string) => void,
  initialDate?: string,
  id?: string,
}

const DateTimePicker: React.FC<Props> = ({
  onChange, initialDate, id = 'datetime-picker-input--',
}) => {
  const [date, setDate] = useState(initialDate || '');
  const ref = useRef(null);
  const onChangeHandler = (dates: Date[]) => {
    const pickedDate = dayjs(dates[0]);
    setDate(pickedDate.format('YYYY/MM/DD HH:mm'));
    onChange(pickedDate.toISOString());
  };

  useEffect(() => {
    const instance = flatpickr(ref.current, {
      disableMobile: true,
      onChange: onChangeHandler,
      locale: Japanese,
      mode: 'single',
      enableTime: true,
      time_24hr: true,
      dateFormat: 'Y/m/d H:i',
      defaultDate: initialDate || undefined,
    });
    return () => instance.destroy();
  }, []);

  return (
    <div
      className="input-group input-group-icon"
      style={{ width: '190px' }}
    >
      <input
        ref={ref}
        onChange={() => ''}
        className="form-control"
        type="text"
        placeholder="yyyy/mm/dd hh:mm"
        id={id}
        value={date}
      />
      <label
        className="input-group-text-icon cursor-pointer"
        htmlFor={id}
      >
        <FontAwesomeIcon icon={faCalendarDays} />
      </label>
    </div>
  );
};

export default DateTimePicker;
